import { Pipe, PipeTransform } from '@angular/core';
import { ConfigurationService } from '@oel/js-configuration';
@Pipe({
  name: 'cheminAbsoluStatique',
  standalone: false,
})
export class CheminAbsoluStatiquePipe implements PipeTransform {
  private readonly CLE_CONFIG_STATIC_SPA_URL = 'oel-static-spa-url';

  /**
   * Cette méthode se base sur la meta oel-static-spa-url pour construire un url absolu à partir d'un chemin relatif.
   * Si la meta n'a pas de valeur associée, on retourne le chemin relatif tel quel.
   *
   * @param  cheminRelatif  chemin relatif qu'on souhaite ajouter à l'url contenu dans la meta oel-static-spa-url
   */
  transform(cheminRelatif: string): string {
    return this.obtenirUrlAbsolu(cheminRelatif) || cheminRelatif;
  }

  /**
   * Retourne l'url complet à partir de la valeur assignée au meta oel-static-spa-url. À noter qu'on s'assure ici d'avoir
   * un "/" à la fin de l'url de base, car l'objet URL le requiert pour retourner un objet avec un bon href.
   *
   * ex:
   *
   * console.log(new URL('mylittlefriend', 'http://hello.com/there').href); ==> http://hello.com/mylittlefriend (pas bon)
   * console.log(new URL('mylittlefriend', 'http://hello.com/there/').href); ==> http://hello.com/there/mylittlefriend (bon)
   *
   * @param cheminRelatif le chemin relatif que l'on souhaite transformer.
   * @private
   */
  private obtenirUrlAbsolu(cheminRelatif: string): string | null {
    const urlBaseSpaStatique = ConfigurationService.getConfig(this.CLE_CONFIG_STATIC_SPA_URL);

    if (urlBaseSpaStatique) {
      const urlBaseNormalise = `${urlBaseSpaStatique}${urlBaseSpaStatique.endsWith('/') ? '' : '/'}`;
      return new URL(cheminRelatif, urlBaseNormalise).href;
    }

    return null;
  }
}
